// Function to fetch and log the current user's name and email
export function logCurrentUserInfo() {
  // Check if ZOHO is available before trying to use it
  if (!window.ZOHO || !window.ZOHO.CRM) {
    console.warn("⚠️ ZOHO SDK not loaded. Cannot fetch user info.");
    return Promise.reject("ZOHO SDK not loaded");
  }

  return ZOHO.CRM.CONFIG.getCurrentUser()
    .then(function (response) {
      if (response && response.users && response.users.length > 0) {
        const user = response.users[0];
        console.log(`✅ User Name: ${user.full_name}`);
        console.log(`✅ User Email: ${user.email}`);
        return user; // Return the user data
      } else {
        console.warn("⚠️ No user details found in the response.");
        return null;
      }
    })
    .catch(function (error) {
      console.error("❌ Error fetching current user details:", error);
      throw error; // Re-throw the error for the caller to handle
    });
}

// Function to safely initialize the ZOHO SDK
export function initializeZohoSDK() {
  if (!window.ZOHO) {
    console.warn("⚠️ ZOHO SDK not available. Running in dev environment?");
    return Promise.resolve(false);
  }

  // Check if we're in a Zoho embedded environment
  const isEmbeddedApp = window.ZOHO && window.ZOHO.embeddedApp;

  if (isEmbeddedApp) {
    return ZOHO.embeddedApp
      .init()
      .then(() => {
        console.log("✅ ZOHO embedded app initialized successfully.");
        return true;
      })
      .catch((error) => {
        console.error("❌ Error initializing ZOHO embedded app:", error);
        return false;
      });
  } else {
    console.warn(
      "⚠️ Not running as an embedded app. Some features may not work."
    );
    return Promise.resolve(false);
  }
}

// The event subscription should only happen in the Zoho environment
if (window.ZOHO && window.ZOHO.embeddedApp) {
  // Subscribe to the PageLoad event
  ZOHO.embeddedApp.on("PageLoad", function () {
    console.log("✅ PageLoad event triggered for user.");
    logCurrentUserInfo(); // Log user details when page loads
  });
}
